import { useAnalytics } from "adapters/analytics";
import { ConfigurationItem } from "constants/configurations";
import {
  getEmailFromStorage,
  getSelectedFarmStateFromStorage,
} from "shared/storageUtils";

type UseConfigurationTabAnalyticsProps = {
  tab: ConfigurationItem;
};

export function useConfigurationTabAnalytics({
  tab,
}: UseConfigurationTabAnalyticsProps) {
  const analytics = useAnalytics();

  const tabToName: Record<ConfigurationItem, string> = {
    [ConfigurationItem.ANIMAL_CATEGORY]: "Categoria Animal",
    [ConfigurationItem.CAUSE_OF_DEATH]: "Causa de Morte",
    [ConfigurationItem.CORRAL_LISTING]: "Listagem de Currais",
    [ConfigurationItem.FARM_GOALS]: "Metas da Fazenda",
    [ConfigurationItem.FORMULATIONS]: "Formulações",
    [ConfigurationItem.HERD_EVOLUTION_AND_NUTRITION_PLAN]:
      "Evolução do Rebanho e Plano Nutricional",
    [ConfigurationItem.INGREDIENTS]: "Ingredientes",
    [ConfigurationItem.LOT_GOALS]: "Metas do Lote",
    [ConfigurationItem.PLOT_LISTING]: "Listagem de Piquetes",
    [ConfigurationItem.RAIN_HISTORY]: "Histórico de Chuvas",
    [ConfigurationItem.SCORE_ADJUSTMENT]: "Ajuste de Pontuação",
    [ConfigurationItem.WEIGHING_BY_CATEGORY]: "Pesagem por Categoria",
    [ConfigurationItem.WEIGHT_GAIN_CURVE]: "Curva de Ganho de Peso",
  };

  const trackEvent = () => {
    const userEmail = getEmailFromStorage();
    const selectedFarm = getSelectedFarmStateFromStorage();
    const tabName = tabToName[tab] ?? "Aba Desconhecida";

    const action = [
      `Acesso aba de configuração "${tabToName[tab] ?? "desconhecida"}"`,
      `pelo usuário "${userEmail ?? "desconhecido"}"`,
      `para a fazenda "${selectedFarm?.Nome ?? "desconhecida"}"`,
    ].join(" ");

    analytics.trackEvent({ action, category: tabName, label: tabName });
  };

  return { trackEvent };
}
